import { motion } from "motion/react";

import { cn } from "@/lib/utils";

/**
 * Issiqlik tasmasi: har katak — bitta soat yoki hafta kuni, rang to'qligi
 * qiymatga mos. "Qachon ishlashadi?" degan savolga ustunlardan tezroq javob.
 */
export function StripChart({
  values,
  labels,
  label,
  every = 1,
}: {
  values: number[];
  labels: string[];
  label: string;
  /** Har nechanchi yorliq yoziladi (24 soatda — har 3-si). */
  every?: number;
}) {
  const max = Math.max(1, ...values);
  const peak = values.indexOf(Math.max(...values));
  return (
    <div role="img" aria-label={label} className="space-y-1.5">
      <div className="flex gap-1">
        {values.map((value, index) => (
          <motion.div
            key={labels[index]}
            title={`${labels[index]}: ${value}`}
            // To'qlik — qiymatga mos shaffoflik; animatsiya aynan shu qiymatga boradi.
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: value === 0 ? 0.08 : 0.15 + (value / max) * 0.85, scale: 1 }}
            transition={{ delay: index * 0.02 }}
            className={cn(
              "bg-primary relative h-10 min-w-0 flex-1 rounded-md transition-transform hover:scale-110",
              index === peak && value > 0 && "ring-primary ring-offset-card ring-2 ring-offset-2",
            )}
          />
        ))}
      </div>
      <div className="flex gap-1">
        {labels.map((text, index) => (
          <span
            key={text}
            className={cn(
              "text-muted-foreground min-w-0 flex-1 text-center text-[10px]",
              index % every !== 0 && "invisible",
            )}
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
